import React from 'react';
import bannerImg from "../../../template/images/quiz-banner.png";
import { useParams } from "react-router-dom";

function QuizBanner() {
  const { id, topic } = useParams();

  const getTopicName = (id) => {
    switch (id) {
      case '33':
        return 'Mutual Fund';
      case '35':
        return 'Personal Finance Quiz 1';
      case '36':
        return 'Personal Finance Quiz 1';
      case '37':
        return 'Master Your Taxes';
      default:
        return 'Quiz';
    }
  };

  const topicName = getTopicName(id);

  return (
    <div className="quiz-banner">
      <img src={bannerImg} alt="Quiz Banner" />
      <span className='quiz-name'>{topicName}</span>
    </div>
  );
}

export default QuizBanner;
